'use client'

import { useState, useEffect } from 'react'

import Logo from './logo'
import { BoxedText } from './boxedText'
import { download, toWeb } from './util'
import './index.css';
import errorImg from './assets/error.png';
import androImg from './assets/andro.png';
import codeImg from './assets/code.png';
import iosImg from './assets/ios.png';
import uploadImg from './assets/upload.png';
import windowsImg from './assets/windows.png';
import topImg from './assets/top.png';
import PopupWrapper from './components/PopupWrapper';
export default function Header() {

  const [isVisible, setIsVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const toggleVisibility = () => {
    setIsVisible(true);
  };
  const hidePopup = () => {
    setIsVisible(false);
  };
  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };
  return (
    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out `} style={{ paddingLeft: 80, paddingRight: 80 }}>
      <div>
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Site branding */}

          <Logo />
          <div className='flex items-center'>
            <div className='w-4px'></div>
            <BoxedText onClick={toWeb} className='text-white'>
              立刻进入web端
            </BoxedText>  <div className='w-[65px]'></div>
            <PopupWrapper child={<BoxedText onClick className='text-white' image={`${process.env.PUBLIC_URL}/images/download.png`} hoverImage={`${process.env.PUBLIC_URL}/images/download_hover.png`} clickImage={`${process.env.PUBLIC_URL}/images/download_click.png`}>
              下载客户端
            </BoxedText>} />
          </div>
          {isVisible ? (<div className='popup'>
            <div className='popup-content'>
              <div className='title'>下载客户端</div>
              <img className='error' onClick={hidePopup} src={errorImg} alt="" />
            </div>
            <div className='list'>
              <div onClick={download} className={`item ${hoveredItem === 'PC' ? 'hovered' : ''}`} onMouseEnter={() => handleMouseEnter('PC')}
                onMouseLeave={handleMouseLeave}>
                <div className='hover'>
                  <div className='round'>
                    <img src={uploadImg} alt="" />
                  </div>
                  <div className='hover-title'>
                    点击下载
                  </div>
                </div>
                <div className='normal'>
                  <img className='cover-img' src={windowsImg} alt="" />

                  PC客户端
                </div>
                <img className='down-icon' src={topImg} alt="" />
              </div>
              <div className={`item ${hoveredItem === 'Android' ? 'hovered' : ''}`}
                onMouseEnter={() => handleMouseEnter('Android')}
                onMouseLeave={handleMouseLeave}>
                <div className="white-box"></div>
                <div className={`hover`}>
                  <img className='code' src={`${process.env.PUBLIC_URL}/images/android_download.jpg`}></img>
                  <div className='hover-title'>
                    扫码下载
                  </div>
                </div>
                <div className='normal'>
                  <img className='cover-img' src={androImg} alt="" />
                  Android
                </div>
                <img className='icon' src={codeImg} alt="" />
              </div>
              <div className={`item ${hoveredItem === 'IOS' ? 'hovered' : ''}`}
                onMouseEnter={() => handleMouseEnter('IOS')}
                onMouseLeave={handleMouseLeave} style={{ margin: 0 }}>
                <div className="white-box"></div>
                <div className={`hover`}>
                  <img className='code' src={`${process.env.PUBLIC_URL}/images/ios_download.jpg`}></img>
                  <div className='hover-title'>
                    扫码下载
                  </div>
                </div>
                <div className='normal'>
                  <img className='cover-img' src={iosImg} alt="" />
                  IOS
                </div>
                <img className='icon' src={codeImg} alt="" />
              </div>
            </div>
          </div>) : ''}
        </div>
      </div>
    </header>
  )
}
